import { Offcanvas, Nav, Tab } from 'react-bootstrap';
import './ViewHistoryOffcanvas.css';

const ViewHistoryOffcanvas = ({
    show,
    onHide,
    historyTab,
    setHistoryTab,
    historyList
}) => {
    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header className='px-4 py-3' closeButton>
                <Offcanvas.Title className='display-1'>Task History</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='p-0'>
                <Tab.Container activeKey={historyTab} onSelect={(key) => setHistoryTab(key)}>
                    <div className="px-4 pb-3 bg-white position-sticky top-0">
                        <Nav variant="tabs" className="c-nav-tabs">
                            <Nav.Item>
                                <Nav.Link eventKey="all">All Activities</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="time">Time Logs</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                    <Tab.Content className="px-4 pb-3 tab-content-scroll">
                        <Tab.Pane eventKey="all">
                            <div>
                                {historyList.map((item, index) => (
                                    <div key={index} className='border p-3 rounded-3 mb-3'>
                                        <div className='p-tag fs-12'>
                                            {item.date} at {item.time}
                                        </div>
                                        <div className='p-tag fw-bold border-bottom pb-2'>{item.user}</div>
                                        <div className='p-tag mt-2'>{item.action}</div>
                                    </div>
                                ))}
                            </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="time">
                            <div>
                                {historyList
                                    .filter(item => item.type === 'time')
                                    .map((item, index) => (
                                        <div key={index} className="border p-3 rounded-3 mb-3">
                                            <div className="p-tag fs-12">
                                                {item.date} at {item.time}
                                            </div>
                                            <div className="p-tag fw-bold border-bottom pb-2">{item.user}</div>
                                            <div className="p-tag mt-2">
                                                <div className="p-tag">
                                                    <strong>Time Log:</strong> 3 Hours 30 Minutes
                                                </div>
                                                <div className="p-tag">
                                                    {item.action}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                {!historyList.some(item => item.type === 'time') && (
                                    <div className="text-center text-muted py-4">
                                        No time logs to display
                                    </div>
                                )}
                            </div>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default ViewHistoryOffcanvas;
